export default __webpack_public_path__ + "static/media/devices.98002870.png";